
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/cloudnative",
      function () {
        return require("private-next-pages/cases/cloudnative/index.tsx");
      }
    ]);
  